import{
  FETCH_MAKE_MODEL_YEAR_REQUEST,
  FETCH_MAKE_MODEL_YEAR_SUCCESS,
  FETCH_MAKE_MODEL_YEAR_FAILURE
} from './MakeModelYearTypes';
import APIManager from '../../ApiManager/ApiManager';

export const fetchMakeModelYearRequest = () => {
  return {
    type: FETCH_MAKE_MODEL_YEAR_REQUEST
  };
}   
export const fetchMakeModelYearSuccess = (data) => {
  return {
    type: FETCH_MAKE_MODEL_YEAR_SUCCESS,
    payload: data   
    };
}

export const fetchMakeModelYearFailure = (error) => {
  return {
    type: FETCH_MAKE_MODEL_YEAR_FAILURE,
    payload: error
  };
};

export const fetchMakeModelYearForPortfolio = (portfolioId) => {
  return async(dispatch) => {
    dispatch(fetchMakeModelYearRequest())
    try {
    const data = await APIManager.getMMYPortfolio(portfolioId);
    dispatch(fetchMakeModelYearSuccess(data));
    } catch (error) {
      dispatch(fetchMakeModelYearFailure(error.message));
    }
  };
};